








































































import mixins from 'vue-typed-mixins';
import { Address, getProvinces } from '@/utils/AddressUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Address,
    },
    loading: {
      type: Boolean as () => boolean,
    },
    disabled: {
      type: Boolean as () => boolean,
    },
  },
  data(): {
    internal: Address;
    provinces?: string[];
  } {
    return {
      internal: {},
      provinces: undefined,
    };
  },
  async mounted() {
    if (this.value) {
      this.internal = this.value;
    }

    try {
      this.provinces = await getProvinces();
    } catch (error) {
      console.error('Error: ', error);
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.internal = this.value;
      }
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.internal);
    },
  },
});
